import {Object3D} from '@wonderlandengine/api';
import {FallingObjectsSpawner} from './falling-objects-spawner.js';
import {FruitPrefabs} from './fruit-prefabs.js';

export class TutorialSpawner extends FallingObjectsSpawner {
    static TypeName = 'tutorial-spawner';
    static InheritProperties = true;

    spawnSequence: string[] = ['Fruit Orange', 'Fruit Green'];
    paused = false;

    private _current = 0;

    protected override spawnNext(): Object3D {
        let obj = null;
        if (this._current < this.spawnSequence.length) {
            //obj = Instantiate(spawnSequence[current], Vector3.zero, Quaternion.identity) as GameObject;
            obj = FruitPrefabs.instance.spawn(
                this.spawnSequence[this._current],
                null,
                false
            );
            this._current++;
        }

        return obj;
    }

    override spawn(): boolean {
        {
            let result = false;
            if (!this.paused) {
                result = super.spawn();
            }
            return result;
        }
    }
}
